import React from 'react';
import { DropDownIcon } from '../../../assets/Icons';
import replacer from '../../../utils/replacer';
import { Spacer } from '../../atoms';
import { DropDown } from '../DropDown/DropDown';
import { DropButton, List } from './style';

type SortProp = {
  sort: string | null;
  setSort: React.Dispatch<React.SetStateAction<string>>;
};

export const SortBy = ({ sort, setSort }: SortProp) => {
  const parsed_sort = sort && replacer(/-/g, ' ', sort);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setSort(e.currentTarget.value);
  };

  const getSortDisplayName = (sortValue: string) => {
    switch (sortValue) {
      case 'product-rating':
        return 'Product Rating';
      case 'popularity':
        return 'Popularity';
      case 'low-to-high':
        return 'Price: Low to High';
      case 'high-to-low':
        return 'Price: High to Low';
      case 'newest-arrivals':
        return 'Newest Arrivals';
      case 'discounted':
        return 'Discounted';
      default:
        return 'Product Rating';
    }
  };

  return (
    <div>
      <DropDown
        x="right"
        label={
          <DropButton>
            Sort: {getSortDisplayName(sort || 'product-rating')} <Spacer width={5} /> <DropDownIcon />
          </DropButton>
        }>
        <>
          <List onClick={handleClick} value="product-rating">
            Product Rating
          </List>
          <List onClick={handleClick} value="popularity">
            Popularity
          </List>
          <List onClick={handleClick} value="low-to-high">
            Price: Low to High
          </List>
          <List onClick={handleClick} value="high-to-low">
            Price: High to Low
          </List>
          <List onClick={handleClick} value="newest-arrivals">
            Newest Arrivals
          </List>
          <List onClick={handleClick} value="discounted">
            Discounted
          </List>
        </>
      </DropDown>
    </div>
  );
};
